import { render } from "./ClassDialog.vue?vue&type=template&id=ec5fd5ce"
import script from "./ClassDialog.vue?vue&type=script&lang=js"
export * from "./ClassDialog.vue?vue&type=script&lang=js"

import "./ClassDialog.vue?vue&type=style&index=0&id=ec5fd5ce&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__